import { Question, CompletedQuestion } from '@openclassrooms/sdk-web';

const formatQuizSessionQuestions = (questions: Question[], values: any): CompletedQuestion[] =>
  questions.map(({ id: questionId, answers }) => {
    const completedAnswers = answers.map(({ id: answerId }) => ({
      id: answerId,
      selected: values[questionId].includes(answerId),
      content: null,
    }));

    return {
      id: questionId,
      answers: completedAnswers,
    };
  });

export default formatQuizSessionQuestions;
